import { PageLayout } from "app/features/navigation/templates/PageLayout";
import { PendingSignOffsTemplate } from "app/features/reporting/templates/PendingSignOffsTemplate";

export default function PendingSignOffsPage() {
  return (
    <PageLayout
      screenName="Pending Sign-Offs"
      titleClassName="text-primary-500"
      headerClassName="border-b-0"
      className="p-dashboard"
    >
      <PendingSignOffsTemplate />
    </PageLayout>
  );
}
